export default "data:image/gif;base64,R0lGODlhBAAEAIAAAFfXNAAAACH5BAAAAAAALAAAAAAEAAQAAAIEhI8JBQA7"